import Vue from 'vue';
import VueRouter from 'vue-router';
import { BootstrapVue } from 'bootstrap-vue';
import App from './App.vue';

import routes from './router';
import './styles/main.scss';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueRouter);

const router = (process.env.NODE_ENV === 'production')
  ? new VueRouter({ mode: 'history', base: '/pages/', routes })
  : new VueRouter({ mode: 'history', routes });

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
